import { FC } from 'react'

import { Card } from '@joor/design-system'

import { ExternalPaymentQuery } from '__generated__/atlas-types'

import { Flex } from 'styles/components'

import {
  CardItemHeader,
  CardItemInfo,
} from '../../PublicInvoice/components/styles'

const BillingInfo: FC<{
  externalPayment: ExternalPaymentQuery['externalPaymentByLink']
}> = ({
  externalPayment: {
    billingAddress,
    billingCity,
    billingCountry,
    billingPostalCode,
    billingState,
    retailerName,
    retailerEmails,
  },
}) => (
  <Card title="Billing Info">
    <Flex flexDirection="column" rowGap="20px">
      <div>
        <CardItemHeader>Customer</CardItemHeader>
        <CardItemInfo>{retailerName}</CardItemInfo>
      </div>
      <div>
        <CardItemHeader>Email</CardItemHeader>
        <CardItemInfo>{retailerEmails.join(', ')}</CardItemInfo>
      </div>
      <div>
        <CardItemHeader>Billing Address</CardItemHeader>
        <CardItemInfo>
          {`${billingAddress}
          ${billingCity}, ${billingState}, ${billingCountry}
          ${billingPostalCode}`}
        </CardItemInfo>
      </div>
    </Flex>
  </Card>
)
export default BillingInfo
